import { useContext } from "react";
import DataContext from "../../../store/data-context";
import NavigationContext from "../../../store/navigation-context";
import styles from "./Gallery.module.css";
import GalleryImage from "./GalleryImage";



export default function Gallery({ category, pageData }) {
  const dataCtx = useContext(DataContext);
  const navCtx = useContext(NavigationContext);


  const onImageShow = (e) => {
    const key = e.currentTarget.getAttribute("value");
    ///
    navCtx.setShowImages({
      state: true,
      images: category.gallery.map((e) => e.src),
      key: parseInt(key),
    });
    ///
  };

  return (
    <main className={styles.main}>
      {category?.gallery?.length > 0 ? (
        <div className={styles.container}>
          {category.gallery.map((image) => {
            return (
              <GalleryImage
                onClick={onImageShow}
                value={image.key}
                key={image.key}
                image={image.src}
              />
            );
          })}
        </div>
      ) : (
        <div className={styles[`no_img`]}>{pageData.no_img}</div>
      )}
    </main>
  );
}
